import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Table, Divider, Button } from "antd";
import { Link } from "react-router-dom";

const columns = [
  {
    title: "Aboneler",
    dataIndex: "email",
    key: "email",
  },
];

function App() {
  const [response, setResponse] = useState([]);

  useEffect(() => {
    Axios.get(baseUrl + "subscription")
      .then((response) => {
        setResponse(response.data.subscription);
      })
      .catch(function (error) {});
  }, []);
  return (
    <div style={{ width: "100%" }}>
      <Table key={"usersTable"} columns={columns} dataSource={response} />
    </div>
  );
}

export default App;
